// The name useSigningActions / useCleverbaseConnection give the Cleverbase
// popup (window.open's second argument), and useQesReturnNotice checks for on
// the popup's landing back in backoffice (`window.name`). Unlike
// `window.opener` — null once the popup has been through Cleverbase's strict
// Cross-Origin-Opener-Policy — `window.name` survives the cross-origin round
// trip. Same approach as lsp-new's CLEVERBASE_POPUP_WINDOW_NAME.
export const QES_POPUP_WINDOW_NAME = 'lk-backoffice-qes-popup'

// Same-origin channel every backoffice tab listens on, so the tab the PM
// clicked "Sign now" / "Connect Cleverbase" in learns the popup's outcome.
export const QES_RETURN_CHANNEL_NAME = 'lk-qes-return'
